import { RouteName } from "@/User/Constants/routes";

export const ALL_ARTICLES = 0;

export const CategoriesArticleItems = [
    { id: 0, content: "すべて", route: RouteName.ArticlesPage },
    { id: 1, content: "フランチャイズ", route: 'franchise' },
    { id: 2, content: "経営", route: 'management' },
    { id: 3, content: "起業", route: 'start-business' },
    { id: 4, content: "副業", route: 'side-job' },
    { id: 5, content: "資金", route: 'funds' },
    { id: 6, content: "脱サラ", route: 'quit-company' },
    { id: 7, content: "早期退職", route: 'early-retirement' },
    { id: 8, content: "独立開業", route: 'independent' },
    { id: 9, content: "個人事業主", route: 'freelance' },
];